import React from 'react';
import { Input } from 'antd';

class NumberInput extends React.Component {
  onChange = e => {
    const { value } = e.target;
    const reg = /[^0-9]*/g;
    if (reg.test(value)) {
      this.props.onChange(value.replace(reg, ''));
    }
  };

  // '.' at the end or only '-' in the input box.
  onBlur = (e) => {
    const { value } = e.target;
    const { onBlur, onChange } = this.props;
    const reg = /[^0-9]*/g;
    if (reg.test(value)) {
      onChange(value.replace(/[^0-9]*/g, ''));
    }
    if (onBlur) {
      onBlur(e);
    }
  };

  render() {
    return (
      <Input
        {...this.props}
        onChange={this.onChange}
        onBlur={this.onBlur}
      />
    );
  }
}
export default NumberInput